import React from 'react'
import Accordion from './accordion/Accordion'
import parse from 'html-react-parser'
import * as E from '../elementor'

type Props = {
  section: E.Section<true>
  template?: string
}

const FAQ = ({ section, template }: Props) => {
  const { image, accordion, heading, textEditor } = E.collect(section)

  return (
    <div className='faq-wrapper'>
      <div className='faq-image'>
        <h2>{parse(heading[0]?.title || '')}</h2>
        <p className='paragraph'>{textEditor[0]?.parse()}</p>
        <img src={image[0]?.image?.fileUrl} alt={image[0]?.image?.altText} />
      </div>
      <div className='faq-content-wrapper'>
        {(!!template && template === 'therapy-type') ? (<>
          <div className='faq-content'>
            <h5>{parse(heading[1]?.title || '')}</h5>
            <Accordion accordion={accordion[0]} template={template} />
          </div>
          {accordion[1] !== undefined &&
            <div className='faq-content'>
              <h5>{parse(heading[2]?.title || '')}</h5>
              <Accordion accordion={accordion[1]} template={template} />
            </div>
          }
        </>) : (<>
          <div className='faq-content'>
            <h3>{parse(heading[1]?.title || '')}</h3>
            <Accordion accordion={accordion[0]} />
          </div>
          {accordion[1] !== undefined &&
            <div className='faq-content'>
              <h3>{parse(heading[2]?.title || '')}</h3>
              <Accordion accordion={accordion[1]} />
            </div>
          }
        </>)}
      </div>
    </div>
  )
}

export default FAQ
